var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "url(#pattern0_501_179)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_501_179",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_501_179",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_501_179",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADl0lEQVR4nO3ZSYhcVRTG8WebGLUJnWASNahxQpwFFSW4iBOi7kwWiojBKaILd45RceNCF1EEF06gqOguCupGwQmiYjA2iCMYZ8WYxCGd1hjzk2tOw8tNvar3Kg+phvpDQ1N17xn63ffdc04XxZAhQ/5XMBP3YV4x3cDeeM5OPsZBxTQN3rRLAkdjQ5bANlxYTBdwHH6M4LfjsmJQweyKz0/GD1haDDJYhUMqvtu/w2ezcWoxKGA5vseSGmvn4V18gJFiEMC+WI8deAYndVgzC1fHkZpieTEo4JJMdT7DajyFV7HF7nzb6Yi1EczhWIHnMY6NIYOT+A4v4ybMz/Y9oDkr2wz8IrzRwPkfuBV7lS6wxxom8FuVivWTwPv644nMzlXYVGPfJ7igleDD8TX659LM1hhuwEtx1iexFV/gSZzXugphFJtLQf2Fh7E4tHs0btjbMZEl8GYxCOChCOhznNBl3cVZApuLQQDHR/ALa6z9vZTAxpr3xc1YGwLwd1yAL2DZlBi0kcSBNdZclz2B93qsH6shEq+0pkhdAjkUj8atW+aOLnuSvNaV53cwo+2gF+F6vBalcc54txsVt2jGnW0n8HqFox1xfit7XhwbEpqTFK6KTa2WGDi7g5PUcS3usW8G1mT71uP89MLiMDxdkcTlrSXQ5SkkBbm2Sj3wYLb+6xR0RT+R83jbCXR6ClO8HX/V/25W7Id7szWTOKXC9j7xZMqsbTWBcDQ3XuZUgHXiV3xY8f2KHrZTUVhmQ+sJlJwd0yWJTjxbw+Zp2Z5tdQLpe04TT6IOa+ooCuZk+ybqBLF0D49TL1JDNKfBGLLMV3U2PdJv/YEDdnG3s645AzdGk39UQ3sHN36JQ4N3qeMbOFySOexZzHWjQ3W7us6mNCX4GUf2XLz73lQPVfYDIY3n9lHG96ytypsW4J9o7WonEYqRmvxKh3HTptnP3JpDhC2ZvbPqBpMmDEIWr+zV5uF0/JQ5S8ks6rA2FX9v9aiVFmBdZu+b2u0mzoynMMWnuBvnpL4gBlLz03GIiUN6WXNWVdi+olQ3rUw3cbSl6edE3IZfOti7q1bwezjPmWJdl+HuSHRfTUhzp9GmCcyMKVpTxnt1b3G+y+PEbmzv+38IUfre06NOn2JrFGuzato+Igq+bqT+ellfwWfOFqaOKMrnJLF/xgjlS7wY0jvWh92R9NeNu+ejEI2J+P3+qvH8kCFDhhQDw7/P8LAYpRPK8AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOm);
export default __webpack_public_path__ + "static/media/om.2322f17146b5f124622024111c8ac94c.svg";
export { ForwardRef as ReactComponent };